<template>
  <!--24内不同开门方式开门次数走势图-->
  <li class="list-item real-open">
    <h3><i class="iconfont iconicon_jiantou"></i>实时人流量数据</h3>
    <div id="realOpen"></div>
  </li>
</template>

<script>
import chartOpt from '../../utils/chartOptions';
export default {
  name: 'realOpen',
  data () {
    return {
      cId: '',
      realOpen: {}
    };
  },
  created () {
    this.getDataViewQuery(this);
  },
  mounted () {
    this.realOpenChart();
  },
  methods: {
    /* 24内不同开门方式开门次数走势图 */
    async realOpenChart () {
      this.realOpen = this.Highcharts.chart('realOpen', chartOpt.realOpenOptions);
      this.getRealOpen();
    },
    /* 获取实时开门 */
    getRealOpen () {
      return new Promise((resolve, reject) => {
        this.$get({
          url: '/zw_statistics/today_opendoor_statistics',
          params: {community_id: this.cId},
          config: { timeout: 20000 }
        }).then(({data}) => {
          let res = this.transformData(data);
          this.realOpen.series[0].setData(res.face);
          this.realOpen.series[1].setData(res.blueTooth);
          this.realOpen.series[2].setData(res.remote);
          this.realOpen.series[3].setData(res.password);
          this.realOpen.series[4].setData(res.card);
          this.realOpen.series[5].setData(res.video);
          this.realOpen.series[6].setData(res.indoorVideo);
          this.realOpen.series[7].setData(res.indoorNet);
          this.realOpen.series[8].setData(res.phone);
          this.realOpen.series[9].setData(res.visitorPwd);

          this.realOpen.xAxis[0].setCategories(res.date);
        });
      });
    }
  }
};
</script>

<style lang="scss" scoped>
  .real-open {
    height: 46vh;
    overflow: hidden;
  }
</style>
